<template>
  <div class="flex items-center justify-center">
    <div
      class="w-8 h-8 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin"
    ></div>
  </div>
</template>
